class EnvService {
  static localOrDev() {
    return ['development', 'local'].includes(process.env.NODE_ENV);
  }
}

export default EnvService;
